import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=86cd8fae&"
import script from "./SplashScreen.vue?vue&type=script&lang=js&"
export * from "./SplashScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports